import React, { ChangeEvent, useState } from "react";
import { toast } from "react-toastify";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H5, LI, P, UL } from "../../../../../../../AbstractElements";
import { AccountType, Continue } from "../../../../../../../Constants/Constants";
import { ActiveCallbackProp } from "../../../../../../../Types/FormsType";
import { SelectAccountTypeData } from "../../../../../../../Data/Forms&Table/Forms/FormLayout";

const ChooseAccount: React.FC<ActiveCallbackProp> = ({ activeCallBack }) => {
  const [formData, setFormData] = useState("");
  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    setFormData(value);
  };
  const handleNextButton = () => {
    if (formData !== "") activeCallBack(2);
    else return toast.error("please fill out all the fields before moving on to the next step");
  };
  return (
    <Form className="needs-validation" noValidate onSubmit={(event) => event.preventDefault()}>
      <Row className="g-3">
        <Col xs="12">
          <H5>{AccountType}</H5>
          <P>{"It has long been known that distracting information on a page will lose a readers attention."}</P>
        </Col>
        <Col xs="12">
          <FormGroup check className="radio radio-primary ps-0 select-account">
            <UL className="radio-wrapper simple-list">
              {SelectAccountTypeData.map((data, index) => (
                <LI key={index}>
                  <Input id={data.title} value={data.title} checked={data.title === formData} type="radio" name="accountType" onChange={updateFormData} />
                  <Label className="mb-0" htmlFor={data.title} check>
                    <i className={`fa fa-${data.icon}`} />
                    <span className="d-flex flex-column">
                      <span>{data.title}</span>
                      <span>{"Search your "}{data.title}{" information please check it"}</span>
                    </span>
                  </Label>
                </LI>
              ))}
            </UL>
          </FormGroup>
        </Col>
        <Col xs="12" className="text-end">
          <Btn onClick={handleNextButton} color="primary">{Continue}</Btn>
        </Col>
      </Row>
    </Form>
  );
};
export default ChooseAccount;
